import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/auth/auth-guard.service';
import { EditionComponent } from './edition/edition.component';
import {ProfileResolver} from './profile-resolver.service';

const routes: Routes = [
  {
    path: 'edition',
    canActivate: [AuthGuard],
    component: EditionComponent,
    resolve: {profile: ProfileResolver}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/profile/profile.routing.ts